var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-pagination',{staticClass:"ui-pagination",attrs:{"value":_vm.value.page,"length":_vm.totalItems,"total-visible":7,"color":"primary"},on:{"input":_vm.onInput}})
}
var staticRenderFns = []

export { render, staticRenderFns }